module.exports = __webpack_public_path__ + "date-insta.png?7c7057230757f99823b808c392fd241a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/date-insta.png
// module id = 156
// module chunks = 0